import * as React from "react";
import { Skeleton as MantineSkeleton } from "@mantine/core";
import styled, { css } from "styled-components";
const StyledSkeleton = styled(MantineSkeleton)(
  ({ theme }) => css`
    &::after {
      background-color: ${theme.colors.gray[80]};
    }
  `
);
const Skeleton = (props) => /* @__PURE__ */ React.createElement(StyledSkeleton, { ...props, radius: "xl" });
export default Skeleton;
